import type { Locale } from "@adpilot/shared";

/**
 * 北京时间（Asia/Shanghai）固定时区的时间格式化（ADP-127）。
 * MVP 阶段所有面向用户的运行时间统一按北京时间展示，不带时区后缀、
 * 不提供时区选择；多国家运营时再单独设计多时区能力。
 */
export const BEIJING_TZ = "Asia/Shanghai";

/** HH:mm，如 "06:00" */
export function formatBeijingTime(value: string | Date): string {
  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZone: BEIJING_TZ,
  }).format(new Date(value));
}

/** 短日期，如 zh-CN "8月24日" / en-US "Aug 24" */
export function formatBeijingDate(value: string | Date, locale: Locale): string {
  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    timeZone: BEIJING_TZ,
  }).format(new Date(value));
}

/** 短日期 + HH:mm，如 "8月24日 06:00" */
export function formatBeijingDateTime(value: string | Date, locale: Locale): string {
  return `${formatBeijingDate(value, locale)} ${formatBeijingTime(value)}`;
}

/** 判断某时刻在北京时区是否落在「今天 + offsetDays」这一天。 */
export function isBeijingDayOffset(
  value: string | Date,
  offsetDays: number,
  now = new Date(),
): boolean {
  const dayKey = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: BEIJING_TZ,
  });
  const ref = new Date(now.getTime() + offsetDays * 86_400_000);
  return dayKey.format(new Date(value)) === dayKey.format(ref);
}
